<template>
    <el-container class="main-layout">
        <el-header class="main-layout__header">
            <div class="main-layout__brand-block">
                <img
                    v-if="showHeaderLogo"
                    :src="siteLogoUrl"
                    alt=""
                    class="main-layout__logo"
                    @error="onLogoError"
                >
                <div class="main-layout__brand">{{ appName }}</div>
            </div>
            <div class="main-layout__user">
                <span class="main-layout__username">{{ currentUserName }}</span>
                <el-button type="text" class="main-layout__logout" @click="handleLogout">退出</el-button>
            </div>
        </el-header>

        <el-container>
            <el-aside width="170px" class="main-layout__aside">
                <el-menu
                    :default-active="activeMenu"
                    :default-openeds="menuDefaultOpeneds"
                    class="main-layout__menu"
                    @select="handleMenuSelect"
                >
                    <el-menu-item v-if="showHomeMenu" index="/">
                        <i class="el-icon-s-home main-layout__menu-icon"></i>
                        <span slot="title">首页</span>
                    </el-menu-item>
                    <el-menu-item v-if="showTodosMenu" index="/todos">
                        <i class="el-icon-s-order main-layout__menu-icon"></i>
                        <span slot="title">待办件</span>
                    </el-menu-item>
                    <el-menu-item v-if="showBizWorkbenchMenus" index="/tax-cleared">
                        <i class="el-icon-s-check main-layout__menu-icon"></i>
                        <span slot="title">已清税</span>
                    </el-menu-item>
                    <el-menu-item v-if="showBizWorkbenchMenus" index="/publicity">
                        <i class="el-icon-s-release main-layout__menu-icon"></i>
                        <span slot="title">公示中</span>
                    </el-menu-item>
                    <el-menu-item v-if="showBizWorkbenchMenus" index="/pending-submit">
                        <i class="el-icon-s-open main-layout__menu-icon"></i>
                        <span slot="title">待提交</span>
                    </el-menu-item>
                    <el-menu-item v-if="showBizWorkbenchMenus" index="/review">
                        <i class="el-icon-s-platform main-layout__menu-icon"></i>
                        <span slot="title">审核中</span>
                    </el-menu-item>
                    <el-menu-item v-if="showBizWorkbenchMenus" index="/reject-resubmit">
                        <i class="el-icon-back main-layout__menu-icon"></i>
                        <span slot="title">驳回单</span>
                    </el-menu-item>
                    <el-menu-item v-if="showBizWorkbenchMenus" index="/complete">
                        <i class="el-icon-s-flag main-layout__menu-icon"></i>
                        <span slot="title">已完成</span>
                    </el-menu-item>
                    <el-menu-item v-if="showLeadsMenu" index="/leads">
                        <i class="el-icon-notebook-2 main-layout__menu-icon"></i>
                        <span slot="title">线索中心</span>
                    </el-menu-item>
                    <el-menu-item v-if="showDispatchMenu" index="/dispatch/manage">
                        <i class="el-icon-connection main-layout__menu-icon"></i>
                        <span slot="title">{{ dispatchMenuTitle }}</span>
                    </el-menu-item>
                    <el-menu-item v-if="showChannelsMenu" index="/channels">
                        <i class="el-icon-s-cooperation main-layout__menu-icon"></i>
                        <span slot="title">渠道订单</span>
                    </el-menu-item>
                    <el-menu-item v-if="showFieldPartnersMenu" index="/field-partners">
                        <i class="el-icon-location-outline main-layout__menu-icon"></i>
                        <span slot="title">{{ navTitleFieldPartners }}</span>
                    </el-menu-item>
                    <el-menu-item v-if="showSettingsMenu" index="/settings/access">
                        <i class="el-icon-s-tools main-layout__menu-icon"></i>
                        <span slot="title">系统配置</span>
                    </el-menu-item>
                </el-menu>
            </el-aside>

            <el-main class="main-layout__main">
                <router-view />
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
import { FIELD_PARTNERS_MODULE_TITLE } from '../../constants/nav-labels';

export default {
    name: 'MainLayout',
    data: function () {
        return {
            navTitleFieldPartners: FIELD_PARTNERS_MODULE_TITLE,
            headerLogoLoadFailed: false
        };
    },
    watch: {
        siteLogoUrl: function () {
            this.headerLogoLoadFailed = false;
        }
    },
    computed: {
        showHeaderLogo: function () {
            return !!(this.siteLogoUrl && !this.headerLogoLoadFailed);
        },
        appName() {
            return this.$store.getters.appName;
        },
        siteLogoUrl() {
            return this.$store.getters.siteLogoUrl;
        },
        currentUserName() {
            var user = this.$store.getters.currentUser;
            return user && user.name ? user.name : '未登录';
        },
        isCancellationSpecialist() {
            var user = this.$store.getters.currentUser;
            var roles = user && user.roles ? user.roles : [];
            return roles.indexOf('cancellation-specialist') >= 0;
        },
        isChannelSpecialist() {
            var user = this.$store.getters.currentUser;
            var roles = user && user.roles ? user.roles : [];
            return roles.indexOf('channel-specialist') >= 0;
        },
        isFieldSpecialist() {
            var user = this.$store.getters.currentUser;
            var roles = user && user.roles ? user.roles : [];
            return roles.indexOf('field-specialist') >= 0;
        },
        isDispatchTaxOnlySpecialist() {
            var user = this.$store.getters.currentUser;
            var roles = user && user.roles ? user.roles : [];
            return roles.indexOf('dispatch-specialist-tax') >= 0
                && roles.indexOf('dispatch-specialist-biz') < 0
                && roles.indexOf('dispatch-specialist-both') < 0;
        },
        isDispatchBizOnlySpecialist() {
            var user = this.$store.getters.currentUser;
            var roles = user && user.roles ? user.roles : [];
            return roles.indexOf('dispatch-specialist-biz') >= 0
                && roles.indexOf('dispatch-specialist-tax') < 0
                && roles.indexOf('dispatch-specialist-both') < 0;
        },
        isDispatchBothSpecialist() {
            var user = this.$store.getters.currentUser;
            var roles = user && user.roles ? user.roles : [];
            return roles.indexOf('dispatch-specialist-both') >= 0;
        },
        dispatchMenuTitle() {
            return this.isDispatchTaxOnlySpecialist ? '已完成订单' : '外派订单';
        },
        dispatchReceiverMenu() {
            var user = this.$store.getters.currentUser;
            return user && user.dispatch_receiver_menu ? user.dispatch_receiver_menu : null;
        },
        hasDispatchReceiverMenuSplit() {
            var m = this.dispatchReceiverMenu;
            return !!(m && typeof m === 'object' && typeof m.tax_stages === 'boolean' && typeof m.biz_stages === 'boolean');
        },
        showHomeMenu() {
            return !this.isChannelSpecialist
                && !this.isFieldSpecialist
                && !this.isDispatchTaxOnlySpecialist
                && !this.isDispatchBizOnlySpecialist
                && !this.isDispatchBothSpecialist;
        },
        hasFullWorkbenchMenus() {
            return !this.isCancellationSpecialist && !this.isChannelSpecialist && !this.isFieldSpecialist && !this.hasDispatchReceiverMenuSplit;
        },
        showTodosMenu() {
            if (this.hasFullWorkbenchMenus) {
                return true;
            }
            if (this.hasDispatchReceiverMenuSplit) {
                return !!this.dispatchReceiverMenu.tax_stages;
            }
            return false;
        },
        showBizWorkbenchMenus() {
            if (this.hasFullWorkbenchMenus) {
                return true;
            }
            if (this.hasDispatchReceiverMenuSplit) {
                return !!this.dispatchReceiverMenu.biz_stages;
            }
            return false;
        },
        showLeadsMenu() {
            return !this.isCancellationSpecialist && !this.isFieldSpecialist && !this.hasDispatchReceiverMenuSplit;
        },
        showChannelsMenu() {
            return !this.isCancellationSpecialist && !this.isFieldSpecialist && !this.hasDispatchReceiverMenuSplit;
        },
        showDispatchMenu() {
            if (this.isChannelSpecialist || this.isFieldSpecialist) {
                return false;
            }
            var user = this.$store.getters.currentUser || {};
            var perms = user.permissions || [];
            return user.is_super_admin || perms.indexOf('dispatch.dispatch') >= 0 || perms.indexOf('dispatch.receive') >= 0 || perms.indexOf('order.edit') >= 0;
        },
        showFieldPartnersMenu() {
            return !this.isCancellationSpecialist && !this.isChannelSpecialist && !this.hasDispatchReceiverMenuSplit;
        },
        showSettingsMenu() {
            return !this.isCancellationSpecialist && !this.isChannelSpecialist && !this.isFieldSpecialist && !this.hasDispatchReceiverMenuSplit;
        },
        activeMenu() {
            var path = this.$route.path || '/';

            if (path === '/' || path === '') {
                if (this.isChannelSpecialist) {
                    return '/channels';
                }
                if (this.isFieldSpecialist) {
                    return '/field-partners';
                }
                return '/';
            }

            if (path.indexOf('/settings/access') === 0) {
                return '/settings/access';
            }

            if (path.indexOf('/settings/permissions') === 0 || path.indexOf('/settings/users') === 0 || path.indexOf('/settings/basic-info') === 0 || path.indexOf('/settings/quick-links') === 0) {
                return '/settings/access';
            }

            if (path.indexOf('/settings/') === 0) {
                return path;
            }

            if (path.indexOf('/leads') === 0 || path.indexOf('/customer-data') === 0) {
                return '/leads';
            }

            if (path.indexOf('/channels') === 0) {
                return '/channels';
            }

            if (path.indexOf('/dispatch/manage') === 0 || path === '/dispatch') {
                return '/dispatch/manage';
            }

            if (path.indexOf('/field-partners') === 0) {
                return '/field-partners';
            }

            if (path.indexOf('/complete') === 0 || path.indexOf('/orders/completed') === 0) {
                return '/complete';
            }

            if (path.indexOf('/field-work') === 0 || path.indexOf('/dispatched-orders') === 0) {
                return '/todos';
            }

            if (path.indexOf('/todos') === 0) {
                return '/todos';
            }

            if (path.indexOf('/tax-cleared') === 0) {
                return '/tax-cleared';
            }

            if (path.indexOf('/publicity') === 0) {
                return '/publicity';
            }

            if (path.indexOf('/pending-submit') === 0) {
                return '/pending-submit';
            }

            if (path.indexOf('/review') === 0) {
                return '/review';
            }

            if (path.indexOf('/reject-resubmit') === 0) {
                return '/reject-resubmit';
            }

            if (path.indexOf('/orders/') === 0) {
                if (this.hasDispatchReceiverMenuSplit && !this.dispatchReceiverMenu.tax_stages && this.dispatchReceiverMenu.biz_stages) {
                    return '/tax-cleared';
                }
                return '/todos';
            }

            return path;
        },
        menuDefaultOpeneds() {
            return [];
        }
    },
    created() {
        this.$store.dispatch('fetchBranding').catch(function () {
        });
    },
    methods: {
        onLogoError() {
            // 仅隐藏顶栏图片，勿清空 Vuex：否则 APP_URL 与访问域名不一致等导致的偶发 404 会抹掉已保存的 logo_url
            this.headerLogoLoadFailed = true;
        },
        normalizePath(p) {
            if (!p || p === '') {
                return '/';
            }

            return p;
        },
        handleMenuSelect(path) {
            if (path === 'config-center') {
                return;
            }
            var target = this.normalizePath(path);
            var current = this.normalizePath(this.$route.path);

            if (current === target) {
                return;
            }

            this.$router.push(target);
        },
        handleLogout() {
            var _this = this;

            this.$store.dispatch('logout').finally(function () {
                _this.$router.replace('/login');
            });
        }
    }
};
</script>

<style scoped>
.main-layout {
    min-height: 100vh;
}

.main-layout__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height: 56px;
    height: auto;
    padding: 10px 14px;
    line-height: 1.2;
    background: #409eff;
    color: #fff;
    padding: 0 14px;
}

.main-layout__brand-block {
    display: flex;
    align-items: center;
    gap: 12px;
    min-width: 0;
}

.main-layout__logo {
    display: block;
    height: 40px;
    max-width: 120px;
    width: auto;
    object-fit: contain;
    flex-shrink: 0;
}

.main-layout__brand {
    font-size: 22px;
    font-weight: 700;
    font-family: "Microsoft YaHei UI", "PingFang SC", "Hiragino Sans GB", sans-serif;
    letter-spacing: 0.3px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.main-layout__user {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;
}

.main-layout__username {
    font-size: 12px;
}

.main-layout__logout {
    padding: 0 8px;
    color: #fff !important;
    font-size: 13px;
}

.main-layout__logout:hover {
    color: #e8f4ff !important;
}

.main-layout__aside {
    background: #fafafa;
    border-right: 1px solid #ebeef5;
}

.main-layout__menu {
    border-right: 0;
    min-height: calc(100vh - 80px);
}

/* 侧栏图标统一占位与字号（流程类多用 el-icon-s-*，语义一致、视觉成套） */
.main-layout__menu .main-layout__menu-icon {
    display: inline-block;
    width: 18px;
    margin-right: 8px;
    font-size: 16px;
    text-align: center;
    vertical-align: middle;
    color: inherit;
}

.main-layout__menu .main-layout__menu-icon--sub {
    width: 16px;
    margin-right: 6px;
    font-size: 15px;
}

.main-layout__menu .el-menu-item {
    height: 46px;
    line-height: 46px;
    font-size: 13px;
}

.main-layout__menu .el-submenu /deep/ .el-submenu__title {
    height: 46px;
    line-height: 46px;
    font-size: 13px;
}

.main-layout__main {
    padding: 0;
    background: #f5f7fa;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/layouts/MainLayout.vue